export interface ICustomBusiness {
    uuid: string;
    id: number;
    confirmed: boolean;
    approved: boolean;
    user_id: number;
    name: string;
    type: string;
    slug: string;
    city: string;
    postal: string;
    street: string;
    email: string;
    phone: string;
    logo: string;
    website: string;
    socials: {};
    general_description: string;
    impact_description: string;
    support_description: string;
    created_at: string;
    updated_at: string;
}

export class CustomBusiness implements ICustomBusiness {
    public uuid: string;
    public id: number;
    public confirmed: boolean;
    public approved: boolean;
    public user_id: number; // tslint:disable-line: variable-name
    public name: string;
    public type: string;
    public slug: string;
    public city: string;
    public postal: string;
    public street: string;
    public email: string;
    public phone: string;
    public logo: string;
    public website: string;
    public socials: {};
    public general_description: string; // tslint:disable-line: variable-name
    public impact_description: string; // tslint:disable-line: variable-name
    public support_description: string; // tslint:disable-line: variable-name
    public created_at: string; // tslint:disable-line: variable-name
    public updated_at: string; // tslint:disable-line: variable-name

    constructor(options: {
        uuid?: string,
        id?: number,
        confirmed?: boolean,
        approved?: boolean,
        user_id?: number,
        name?: string,
        type?: string,
        slug?: string,
        city?: string,
        postal?: string,
        street?: string,
        email?: string,
        phone?: string,
        logo?: string,
        website?: string,
        socials?: {},
        general_description?: string,
        impact_description?: string,
        support_description?: string,
        created_at?: string,
        updated_at?: string,
    } = {}) {
        this.uuid = options.uuid || '';
        this.id = options.id || null;
        this.confirmed = !!options.confirmed;
        this.approved = !!options.approved;
        this.user_id = options.user_id || 1;
        this.name = options.name || '';
        this.type = options.type || '';
        this.city = options.city || '';
        this.postal = options.postal || '';
        this.street = options.street || '';
        this.slug = options.slug || '';
        this.email = options.email || '';
        this.phone = options.phone || '';
        this.logo = options.logo || '';
        this.website = options.website || '';
        this.socials = options.socials || {};
        this.general_description = options.general_description || '';
        this.impact_description = options.impact_description || '';
        this.support_description = options.support_description || '';
        this.created_at = options.created_at || '';
        this.updated_at = options.updated_at || '';

    }
}
